<template>
  <div>
    <el-row>
      <el-col>
        <div id="editor" :height="height" class="editorBox"></div>

        <!--<div class="btn-box">
          <button @click="getContent">查看内容</button>
        </div>-->

      </el-col>
    </el-row>
  </div>
</template>

<script>
import wangEditor from 'wangeditor'
import {baseURL} from '@/utils/getawayModule'

export default {
  props: {
    height: {
      type: Number,
      default: 300
    },
    type: {
      type: String,
      default: 'html'
    },
    editorContent: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'editorContent',//指向props的参数名
    event: 'change'//事件名称
  },
  data() {
    return {
      editor: null,
      editorData: ''
    }
  },
  watch: {
    editorContent(val) {
      this.$nextTick(() => {
        //设置修改的值
        this.editor.txt.html(val);
      })
    }
  },
  mounted() {
    //const html = editor.txt.html()
    // const safeHtml = xss(html)
    let that = this
    const editor = new wangEditor(`#editor`)
    editor.config.height = this.height
    //隐藏网络图片
    editor.config.showLinkImg = false
    //隐藏网络视频
    editor.config.showLinkVideo = false
    editor.config.uploadImgServer = `${baseURL.userApi}/file/upload`
    editor.config.uploadImgMaxSize = 3 * 1024 * 1024
    editor.config.uploadImgMaxLength = 10
    editor.config.uploadFileName = 'file'
    editor.config.uploadImgHooks = {
      // eslint-disable-next-line no-unused-vars
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        if (result.code === '0') {
          let adminUrl = result.data.realPath
          insertImg(adminUrl)
        } else {
          this.$message.error('上传文件失败,请稍后重试!')
        }

      }
    }
    editor.config.uploadVideoServer = `${baseURL.userApi}/file/upload`
    editor.config.uploadVideoMaxSize = 0.5 * 1024 * 1024 * 1024
    editor.config.uploadVideoAccept = ['mp4']
    editor.config.uploadVideoName = 'file'
    editor.config.uploadVideoHooks = {
      customInsert: function (insertVideoFn, result) {
        if (result.code === '0') {
          //let url = `${baseURL.userApi}/file/${result.data.md5}/download`
          let url = result.data.realPath
          insertVideoFn(url)
        } else {
          this.$message.error('上传视频失败,请稍后重试!')
        }
      }
    }
    editor.config.colors = []
    editor.config.fontNames = ['']
    editor.config.backColor = ['']
    editor.config.head = []
    /*editor.config.fontSizes = {
      '122': {name: '0px', value: '0'},
      '123': {name: '20px', value: '2'},
    }*/
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.config.onchange = (newHtml) => {
      this.editorData = newHtml
      //推送定义的getData事件
      this.$emit('getData', newHtml)
      //推送绑定的v-model事件
      this.$emit('change', newHtml)
    }
    //自定义提示
    editor.config.customAlert = function (s, t) {
      switch (t) {
        case 'success':
          that.$message.success(s)
          break
        case 'info':
          that.$message.info(s)
          break
        case 'warning':
          that.$message.warning(s)
          break
        case 'error':
          that.$message.error(s)
          break
        default:
          that.$message.info(s)
          break
      }
    }
    // 创建编辑器
    editor.create()
    editor.txt.html(this.editorContent)
    this.editor = editor
  },
  methods: {
    //获取编辑器内容
    getData() {
      let data = null
      let editor = this.editor
      let type = this.type
      switch (type) {
        case  'html':
          data = editor.txt.html()
          break
        case  'json' :
          data = editor.txt.getJSON()
          break
        case  'text':
          data = editor.txt.text()
          break
        default:
          data = editor.txt.html()
          break
      }
      this.$emit('getData', data)
    },

    //查看内容
    getContent: function () {
      alert(this.editorContent)
    }
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style lang="less" scoped>

/deep/.editorBox {
  .w-e-toolbar {
    z-index: 998 !important;
  }

  .w-e-text-container {
    z-index: 997 !important;
  }
}




#editor {
  position: relative;
}

#editor .btn-box {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

</style>
